/**
 * character 领域的 GameState 分片注册（角色注册表 + 角色关系快照）。
 * 由 app/gameStateSlices.ts 清单挂载；字段类型经 declare module 增补到 GameStateSlices。
 */

import { registerGameStateSlice } from '@/IsekaiRPG/modules/runtime/gameStateRegistry';
import { CharacterRegistryStateSchema, type CharacterRegistryState } from './types/characterRegistry';
import { CharacterRelationsPersistenceStateSchema, type CharacterRelationsPersistenceState } from './types/relation';

declare module '@/IsekaiRPG/modules/runtime/gameStateRegistry' {
  interface GameStateSlices {
    characters?: CharacterRegistryState;
    /**
     * 角色关系持久化快照（玩家 ↔ 角色），由 `useCharacterRelationsStore` 提供 snapshot/hydrate。
     * 仍保留 optional，便于兼容手动导入或异常残缺数据；正常存档会在迁移/保存时补成显式快照。
     */
    characterRelations?: CharacterRelationsPersistenceState;
  }
}

registerGameStateSlice('characters', CharacterRegistryStateSchema.optional(), () => ({
  registry: {},
  runtimeStates: {},
}));

registerGameStateSlice('characterRelations', CharacterRelationsPersistenceStateSchema.optional());
